import React from 'react';
import Button from 'react-bootstrap/Button'

export default React.forwardRef(({ loading, className, children, ...props }, ref) => {
  className = "focus:outline-none flex-row d-flex items-center flex-nowrap"+(className?' '+className:'')
  return (
    <Button
      disabled={loading}
      className={className}
      ref={ref}
      {...props}
    >
      {loading && <div className="btn-spinner mr-2" />}
      {children}
    </Button>
  );
});
